import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-hot-toast';

// Create an Axios instance with default settings
const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/v1`, // Base API URL from environment variable
    timeout: 120000, // Set timeout for requests (2 minutes for video generation)
});

// Interceptor to attach token and signature dynamically
axiosInstance.interceptors.request.use(
    config => {
        const token = Cookies.get('auth_token'); // Retrieve token from cookies

        // Attach Authorization token if available
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        // Dynamically set the Content-Type
        if (config.data instanceof FormData) {
            // If request contains files, use multipart/form-data
            config.headers['Content-Type'] = 'multipart/form-data';
        } else {
            // Default for JSON requests
            config.headers['Content-Type'] = 'application/json';
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle success and errors globally
axiosInstance.interceptors.response.use(
    response => {
        // Show success toast for Create/Edit/Delete operations
        const method = response.config?.method?.toLowerCase();
        if (['post', 'put', 'patch', 'delete'].includes(method || '')) {
            const message = (response?.data as any)?.message;
            toast.success(message || 'Operation completed successfully.');
        }
        return response;
    },
    error => {
        const status = error?.response?.status;
        const method = error?.config?.method?.toLowerCase();

        // Show error toast for Create/Edit/Delete operations
        if (['post', 'put', 'patch', 'delete'].includes(method || '')) {
            const message = error?.response?.data?.message;
            toast.error(message || 'Error performing operation.');
        }

        if (status === 401) {
            console.warn("Unauthorized! Token may be invalid or expired.");
            Cookies.remove('auth_token');
            window.location.href = '/login';
        } else if (error?.response) {
            console.log(`API Error: ${error.response.status} - ${error.response.data?.message || error.message}`);
        } else {
            console.log("Network error or no response from server.");
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
